import { createContext, useCallback, useContext } from 'react';
import * as React from 'react';
const store = createContext({ setState: () => null });
const { Provider } = store;
export const ApiErrorHandlerProvider = (props) => {
    const { children, onClientError, onRedirect, onServerError } = props;
    // Dispatch an error if the application is listening and a new error exists
    const setState = (response) => {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
        if (response) {
            if (onRedirect && response.status >= 300 && response.status < 400) {
                onRedirect(response);
            }
            else if (onClientError && response.status >= 400 && response.status < 500) {
                onClientError(response);
            }
            else if (onServerError && response.status >= 500 && response.status < 600) {
                onServerError(response);
            }
            else {
                if (console === null || console === void 0 ? void 0 : console.error) {
                    console.error(response);
                }
            }
            setState(undefined);
        }
    };
    return React.createElement(Provider, { value: { setState } }, children);
};
export function useApiErrorHandler() {
    const errorContext = useContext(store);
    // This library or the application can raise an error from anywhere in the system
    const raiseError = useCallback((response) => {
        errorContext.setState(response);
    }, [errorContext]);
    return { raiseError };
}
//# sourceMappingURL=index.js.map